export let ONESIGNAL_APP_ID = {
    CM: 'bf6188e0-b3f6-4151-be67-bdebaff6e780',
    LM: 'a5cb0bb3-7b07-4fc2-b6f2-bb8aaf28b5ff'
};
